import { ACCOUNT_EXPORT_FORMAT, ACCOUNT_EXPORT_MANIFEST_PATH } from "@rakazo/contracts";
import { strFromU8, unzipSync } from "fflate";

const MANIFEST_MAX_BYTES = 1024 * 1024;

/**
 * Whether a zip is one teammate exported from this product (an account-export archive with
 * `manifest.teammate`), read from its manifest alone so the rest is never unpacked here.
 */
export function isTeammateArchive(bytes: Uint8Array): boolean {
  try {
    const files = unzipSync(bytes, {
      filter: (file) =>
        file.name === ACCOUNT_EXPORT_MANIFEST_PATH && file.originalSize <= MANIFEST_MAX_BYTES,
    });
    const manifest = files[ACCOUNT_EXPORT_MANIFEST_PATH];
    if (!manifest) return false;
    const parsed = JSON.parse(strFromU8(manifest)) as {
      format?: unknown;
      teammate?: { botId?: unknown };
    } | null;
    return parsed?.format === ACCOUNT_EXPORT_FORMAT && typeof parsed.teammate?.botId === "string";
  } catch {
    return false;
  }
}
